// threadSummaries.js — derive thread summary rows from reply messages

function toMillis(value) {
  if (!value) return 0;
  if (typeof value?.toMillis === 'function') return value.toMillis();
  if (value instanceof Date) return value.getTime();
  const parsed = Date.parse(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function buildThreadSummariesByRootKey(rows) {
  const summaries = {};

  for (const row of Array.isArray(rows) ? rows : []) {
    if (row?.dateDeleted) continue;

    const rootKey = String(row?.threadRootKey || '').trim();
    const parentKey = String(row?.parentMessageKey || '').trim();
    if (!rootKey || !parentKey) continue;

    if (!summaries[rootKey]) {
      summaries[rootKey] = {
        replyCount: 0,
        lastReplyAt: null,
      };
    }

    summaries[rootKey].replyCount += 1;

    const createdMs = toMillis(row.dateCreated);
    const lastMs = toMillis(summaries[rootKey].lastReplyAt);
    if (createdMs >= lastMs) {
      summaries[rootKey].lastReplyAt = row.dateCreated;
    }
  }

  return summaries;
}

export function resolveThreadSummary(message, threadSummariesByRootKey = {}) {
  const messageKey = String(message?.key || '').trim();
  const fromMessage = {
    replyCount: Number(message?.replyCount) || 0,
    lastReplyAt: message?.lastReplyAt || null,
  };
  const fromReplies = messageKey ? threadSummariesByRootKey[messageKey] : null;
  const replyCountFromReplies = Number(fromReplies?.replyCount) || 0;

  return {
    replyCount: Math.max(fromMessage.replyCount, replyCountFromReplies),
    lastReplyAt: fromMessage.lastReplyAt || fromReplies?.lastReplyAt || null,
  };
}
